import { call, put, takeLatest } from "redux-saga/effects";
import { LoginActions } from "./index";

function* handleLogout() {
  try {
    const currentPath = window.location.pathname + window.location.search;

    sessionStorage.setItem("redirectAfterLogin", currentPath);
    yield call(fetch, "/api/auth/logout", {
      method: "GET",
      credentials: "include"
    });

    yield put(LoginActions.logoutSuccess());

    sessionStorage.setItem("redirectAfterLogin", currentPath);
    window.location.href = "/login";
  } catch (err) {
    yield put(LoginActions.logoutError(err.message));
  }
}

export function* logoutSaga() {
  yield takeLatest(LoginActions.logoutRequest.type, handleLogout);
}
